import { render, staticRenderFns } from "./WorkflowDataPanel.vue?vue&type=template&id=f49fee12"
import script from "./WorkflowDataPanel.vue?vue&type=script&lang=js"
export * from "./WorkflowDataPanel.vue?vue&type=script&lang=js"
import style0 from "./mqSharedStyles.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49fee12')) {
      api.createRecord('f49fee12', component.options)
    } else {
      api.reload('f49fee12', component.options)
    }
    module.hot.accept("./WorkflowDataPanel.vue?vue&type=template&id=f49fee12", function () {
      api.rerender('f49fee12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowDataPanel.vue"
export default component.exports